import { AppState } from 'store/store';
import { recordsReducer } from 'features/trends/store/records/records-store';

export const trendsReducer = {
    trends: recordsReducer,
};

export type TrendsState = AppState;
